<template>
  <div class="medal-manager">


    <!-- 勋章配置表格 -->
    <el-table
      :data="tableData"
      border
      stripe
      highlight-current-row=""
      style="width: 100%; margin-top: 20px"
      :cell-style="{ 'text-align': 'center' }"
      :header-cell-style="{ 'text-align': 'center' }"
      class="custom-padding-table"
    >
      
      <el-table-column prop="configName" label="配置名" width="200" />
      <el-table-column prop="configValue" label="值" width="200" />
      <el-table-column prop="description" label="配置说明" width="200" />
      <el-table-column prop="configKey" label="编号" width="80" />
       <el-table-column prop="isEnable" label="是否启用" width="100">
        <template #default="scope">
          <el-tag type="success"  v-if="scope.row.isEnable">启用</el-tag>
          <el-tag type="info"  v-if="!scope.row.isEnable">禁用</el-tag>
        </template>
       </el-table-column>
      <el-table-column label="操作时间" prop="updateTime"> </el-table-column>
      <el-table-column label="操作人" prop="updateUserName"> </el-table-column>
    </el-table>

    
  </div>
</template>

<script>
import { getPointRecordList } from "../../../api/api";

export default {
  name: "MedalManager",
  data() {
    return {
      // 勋章列表数据（初始化与图片一致）
      tableData: [],
      listLoading: false,
      id:''
     
    };
  },

  methods: {
    getList() {
      let params = {
        id:this.id
      };
      getPointRecordList(params).then((res) => {
        if (res.data.success) {
          this.tableData = res.data.response;
        }
      });
    },
  },
  mounted() {
    this.id =  this.$route.query.id,
    this.getList();
  },
};
</script>

<style lang="stylus" scoped>
.medal-manager {
  padding: 20px;
}

.avatar-uploader {
  width: 178px;
  height: 178px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  /* margin: 0 auto; */
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c8c8c;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.pageBar {
  margin-top: 15px;
}


/* 👇👇👇 新增的样式开始 👇👇👇 */
.custom-padding-table
  ::v-deep .el-table__cell
    /* 上下内边距，根据需要调整数值，默认通常是 8px 或 10px */
    padding-top: 16px
    padding-bottom: 16px
    
  /* 如果上面的写法在某些构建环境下不生效，可以尝试加 !important 强制覆盖 */
  ::v-deep td.el-table__cell
    padding-top: 16px !important
    padding-bottom: 16px !important
/* 👆👆👆 新增的样式结束 👆👆👆 */
</style>